import { Link } from "react-router-dom";
import { MapPin, CalendarCheck, Star, ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import SafeImage from "@/components/SafeImage";
import { Reveal, Kicker } from "@/components/Reveal";
import { FinalCTA } from "@/pages/Home";
import { useSettings } from "@/context/SettingsContext";

const ABOUT_IMG = "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&w=1100&q=70";

export default function About() {
  const s = useSettings();
  return (
    <>
      <SEO
        title="About Us | Hari Om Trading Co. — Tahliwal, Una"
        description="Hari Om Trading Co. is based in Tahliwal, Una, Himachal Pradesh and supplies electrical and industrial products for commercial, workshop and industrial requirements."
      />
      <section className="grain bg-[#111111] bg-grid-dark py-16 lg:py-24" data-testid="about-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <Kicker dark>About</Kicker>
            <h1 className="mt-4 max-w-3xl font-heading text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
              Your Local Industrial &amp; Electrical Supply Partner
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-24" data-testid="about-content">
        <div className="mx-auto grid max-w-7xl gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:items-center">
          <Reveal>
            <div className="clip-frame-tl">
              <SafeImage src={ABOUT_IMG} alt="Industrial machinery and equipment" className="aspect-[4/3] w-full object-cover" data-testid="about-image" />
            </div>
            <p className="mt-3 text-xs text-[#667085]">Demo stock image — replace with an authentic business photo. [ADD BUSINESS PHOTO]</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-heading text-3xl font-bold tracking-tight text-[#161616] lg:text-4xl">
              Based in Tahliwal. Built for Industry.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-[#667085]">
              Hari Om Trading Co. is based in Tahliwal, Una, Himachal Pradesh and supplies a range of
              electrical and industrial products for commercial, workshop and industrial requirements.
            </p>
            <p className="mt-4 text-base leading-relaxed text-[#667085]">
              The catalogue covers industrial automation, switchgear, lighting, pneumatic products,
              electrical products and industrial tools — including Multispan automation products,
              Crompton lighting and DeWalt tools as available.
            </p>
            <p className="mt-4 font-mono text-sm text-[#98a2b3]" data-testid="about-history-placeholder">
              [ADD BUSINESS HISTORY — editable field for the story of the company]
            </p>
            <div className="mt-8 grid gap-4 sm:grid-cols-3">
              {[
                { icon: CalendarCheck, label: `Est. ${s.established}` },
                { icon: Star, label: `${s.google_rating}★ · ${s.google_reviews_count} reviews` },
                { icon: MapPin, label: "Tahliwal, Una" },
              ].map((f, i) => (
                <div key={i} className="border border-[#D9DDE3] bg-[#F6F7F8] p-4" data-testid={`about-fact-${i}`}>
                  <f.icon size={20} className="text-[#F5B700]" aria-hidden="true" />
                  <p className="mt-2.5 font-heading text-sm font-semibold text-[#161616]">{f.label}</p>
                </div>
              ))}
            </div>
            <Link
              to="/products"
              data-testid="about-browse-products"
              className="mt-9 inline-flex min-h-[48px] items-center gap-2 bg-[#111111] px-6 py-3 font-heading text-[15px] font-semibold text-white hover:bg-[#F5B700] hover:text-[#111111]"
            >
              Browse the catalogue <ArrowRight size={16} aria-hidden="true" />
            </Link>
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </>
  );
}
